import { useQueryClient } from '@tanstack/react-query';
import { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import organizationEventEmitter from 'src/utilities/organizationEmmiter';

export type SuperAdminContextTypes = {
  org: {
    org_uuid: string;
  } | null;
};

export const SuperAdminContext = createContext<SuperAdminContextTypes>({
  org: null,
});

export type SuperAdminScopeProps = {
  children: React.ReactNode;
};

export const SuperAdminScope = ({ children }: SuperAdminScopeProps) => {
  const queryClient = useQueryClient();

  const { currentPractitioner } = useSelector(
    (state: any) => state?.practitionerState
  );
  const [org_uuid, setOrgUuid] = useState(() => {
    const savedOrg = localStorage.getItem('superAdminSelectedOrganization');
    const parsedSavedOrg = savedOrg ? JSON.parse(savedOrg) : null;
    return parsedSavedOrg?.org_uuid || currentPractitioner?.org_uuid || null;
  });

  useEffect(() => {
    const unsubscribe = organizationEventEmitter.subscribe(
      'organizationChanged',
      (newOrg: { org_uuid: string }) => {
        const newOrgUuid = newOrg?.org_uuid || null;
        if (newOrgUuid !== org_uuid) {
          queryClient.clear();
        }
        setOrgUuid(newOrgUuid);
      }
    );

    return () => unsubscribe();
  }, [org_uuid]);

  return (
    <SuperAdminContext.Provider value={{ org: { org_uuid } }}>
      {children}
    </SuperAdminContext.Provider>
  );
};
